import { getActiveExperienceCode, getReviewPage, getSelectedBusinessLine } from '../../../reducers';
import { createSelector } from '@ngrx/store';
import { DraftState, ReviewBaseState } from './index';
import { ProductType } from '@cemex-core/cmx-api/models/business-lines/product-type';

export const getDraftState = createSelector(getReviewPage, (state: ReviewBaseState) => state.draft);

export const getOrderDraft = createSelector(getDraftState, state => state.orderDraft);

export const getOrderDraftId = createSelector(getDraftState, state => state.orderDraftId);

export const getPumpingService = createSelector(getDraftState, state => state.cemexPumpServices);

export const getDraftRequestData = createSelector(
  getDraftState,
  getSelectedBusinessLine,
  getActiveExperienceCode,
  (draftState: DraftState, selectedBusinessLine: ProductType, experienceCode) => {
    return { draftState, selectedBusinessLine, experienceCode };
  },
);
